export const applyCpfMask = (cpf) => {
    let maskedCpf = cpf;

    if (cpf && cpf.length === 11) {
        maskedCpf = `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(6, 9)}-${cpf.slice(9)}`;
    }

    return maskedCpf;
}

export const parseCompanyName = (companyName) => {
    let parsedCompanyName = companyName;

    switch (companyName) {
        case 'affinity':
            parsedCompanyName = 'Affinity';
            break;
        case 'assist-card':
            parsedCompanyName = 'AssistCard';
            break;
        case 'universal-assistance':
            parsedCompanyName = 'Universal Assistance';
            break;
    }

    return parsedCompanyName;
}

export const parsePaymentMethod = (paymentMethod) => {
    let parsedPaymentMethod = paymentMethod;

    switch (paymentMethod) {
        case 'credit-card':
            parsedPaymentMethod = 'Cartão de Crédito';
            break;
        case 'pix':
            parsedPaymentMethod = 'Pix';
            break;
        case 'bank-slip':
            parsedPaymentMethod = 'Boleto Bancário';
            break;
        case 'bank-transfer':
            parsedPaymentMethod = 'Transferência Bancária';
            break;
    }

    return parsedPaymentMethod;
}
